import React from 'react';
import { Document, Page, Text, View, Image } from '@react-pdf/renderer';
import { sharedStyles } from './SharedPDFStyles';

const OtoTamirReportPDF = ({ data, logos }) => {
  return (
    <Document>
      <Page size="A4" style={sharedStyles.page}>
        <View style={sharedStyles.header}>
          <View style={sharedStyles.businessInfo}>
            {logos.length > 0 && (
              <View style={sharedStyles.logoContainer}>
                {logos.slice(0, 3).map((logo, index) => (
                  <Image key={index} src={logo.data} style={sharedStyles.logo} />
                ))}
              </View>
            )}
            <Text style={sharedStyles.businessName}>{data.garageName || 'Garage Name'}</Text>
          </View>
          <View style={sharedStyles.documentTitle}>
            <Text style={sharedStyles.title}>Service Invoice</Text>
            <Text style={sharedStyles.documentInfo}>Date: {data.date}</Text>
            <Text style={sharedStyles.documentInfo}>Customer: {data.customerName}</Text>
            <Text style={sharedStyles.documentInfo}>Vehicle: {data.vehicleInfo}</Text>
            <Text style={sharedStyles.documentInfo}>Service Date: {data.serviceDate}</Text>
          </View>
        </View>

        <View style={sharedStyles.section}>
          <Text style={sharedStyles.sectionTitle}>Services</Text>
          <View style={sharedStyles.table}>
            <View style={sharedStyles.tableHeader}>
              <Text style={{ ...sharedStyles.tableCell, flex: 3 }}>Service Name</Text>
              <Text style={sharedStyles.tableCellCenter}>Qty</Text>
              <Text style={sharedStyles.tableCellRight}>Unit Price</Text>
              <Text style={sharedStyles.tableCellRight}>Total</Text>
            </View>
            {data.services && data.services.map((service, index) => (
              <View key={index} style={sharedStyles.tableRow}>
                <Text style={{ ...sharedStyles.tableCell, flex: 3 }}>{service.serviceName}</Text>
                <Text style={sharedStyles.tableCellCenter}>{service.quantity}</Text>
                <Text style={sharedStyles.tableCellRight}>${service.unitPrice.toFixed(2)}</Text>
                <Text style={sharedStyles.tableCellRight}>${service.total.toFixed(2)}</Text>
              </View>
            ))}
          </View>
        </View>

        <View style={sharedStyles.section}>
          <Text style={sharedStyles.sectionTitle}>Parts</Text>
          <View style={sharedStyles.table}>
            <View style={sharedStyles.tableHeader}>
              <Text style={{ ...sharedStyles.tableCell, flex: 3 }}>Part Name</Text>
              <Text style={sharedStyles.tableCellCenter}>Qty</Text>
              <Text style={sharedStyles.tableCellRight}>Unit Price</Text>
              <Text style={sharedStyles.tableCellRight}>Total</Text>
            </View>
            {data.parts && data.parts.map((part, index) => (
              <View key={index} style={sharedStyles.tableRow}>
                <Text style={{ ...sharedStyles.tableCell, flex: 3 }}>{part.partName}</Text>
                <Text style={sharedStyles.tableCellCenter}>{part.quantity}</Text>
                <Text style={sharedStyles.tableCellRight}>${part.unitPrice.toFixed(2)}</Text>
                <Text style={sharedStyles.tableCellRight}>${part.total.toFixed(2)}</Text>
              </View>
            ))}
          </View>
        </View>

        <View style={sharedStyles.summary}>
          <View style={sharedStyles.summaryBox}>
            <View style={sharedStyles.summaryRow}>
              <Text style={sharedStyles.summaryLabel}>Services Total:</Text>
              <Text style={sharedStyles.summaryValue}>${data.serviceTotal?.toFixed(2) || '0.00'}</Text>
            </View>
            <View style={sharedStyles.summaryRow}>
              <Text style={sharedStyles.summaryLabel}>Parts Total:</Text>
              <Text style={sharedStyles.summaryValue}>${data.partsTotal?.toFixed(2) || '0.00'}</Text>
            </View>
            <View style={sharedStyles.summaryRow}>
              <Text style={sharedStyles.summaryLabel}>Subtotal:</Text>
              <Text style={sharedStyles.summaryValue}>${data.subtotal?.toFixed(2) || '0.00'}</Text>
            </View>
            {/* Tax sadece varsa göster */}
            {data.taxRate > 0 && (
              <View style={sharedStyles.summaryRow}>
                <Text style={sharedStyles.summaryLabel}>Tax ({data.taxRate}%):</Text>
                <Text style={sharedStyles.summaryValue}>${data.tax?.toFixed(2) || '0.00'}</Text>
              </View>
            )}
            <View style={sharedStyles.summaryTotal}>
              <Text style={sharedStyles.summaryTotalLabel}>Grand Total:</Text>
              <Text style={sharedStyles.summaryTotalValue}>${data.grandTotal?.toFixed(2) || '0.00'}</Text>
            </View>
          </View>
        </View>

        {data.notes && (
          <View style={sharedStyles.notes}>
            <Text style={sharedStyles.notesTitle}>Service Notes:</Text>
            <Text style={sharedStyles.notesText}>{data.notes}</Text>
          </View>
        )}

        <View style={sharedStyles.footer}>
          <Text>© 2025 SODEA  Crafted by Eng. Mohamed Ibrahim Abdi (Moha-Qadar) | 🎓 KTÜ & Firat University | 📧 mohamedqadar280@gmail.com | 💬 Feedback</Text>
        </View>
      </Page>
    </Document>
  );
};

export default OtoTamirReportPDF;
